// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"B97s7"};